export default __webpack_public_path__ + "static/media/hsbc-logo-5.88335ba9.png";